module.exports = __webpack_public_path__ + "img/运维设备.cc1dd2ba.png";